class PurchaseNotification {
  constructor() {
    this.femaleNames = [
      'Emma', 'Olivia', 'Sophia', 'Isabella', 'Ava', 'Mia', 'Charlotte', 'Amelia',
      'Harper', 'Evelyn', 'Abigail', 'Emily', 'Ella', 'Elizabeth', 'Camila', 'Luna',
      'Sofia', 'Avery', 'Mila', 'Aria', 'Scarlett', 'Penelope', 'Layla', 'Chloe',
      'Victoria', 'Madison', 'Eleanor', 'Grace', 'Nora', 'Riley', 'Zoey', 'Hannah',
      'Hazel', 'Lily', 'Ellie', 'Violet', 'Lillian', 'Zoe', 'Stella', 'Aurora',
      'Natalie', 'Emilia', 'Everly', 'Leah', 'Aubrey', 'Willow', 'Addison', 'Lucy',
      'Audrey', 'Bella', 'Nova', 'Brooklyn', 'Paisley', 'Savannah', 'Claire', 'Skylar',
      'Isla', 'Genesis', 'Naomi', 'Elena', 'Caroline', 'Eliana', 'Anna', 'Maya',
      'Valentina', 'Ruby', 'Kennedy', 'Ivy', 'Ariana', 'Aaliyah', 'Cora', 'Madelyn',
      'Alice', 'Kinsley', 'Hailey', 'Gabriella', 'Allison', 'Gianna', 'Serenity', 'Samantha'
    ];
    
    this.notification = document.getElementById('purchase-notification');
    this.nameElement = null;
    this.intervalId = null;
    this.isVisible = false;
    this.displayDuration = 4000; // 4 seconds
    this.minIntervalDuration = 30000; // 30 seconds minimum
    this.maxIntervalDuration = 50000; // 50 seconds maximum
    
    // FOMO stock management
    this.currentStock = 29; // Starting stock count
    this.minStock = 5; // Reset when it gets this low
    this.maxStock = 35; // Reset to this amount
    
    this.init();
  }
  
  init() {
    if (!this.notification) {
      console.warn('Purchase notification element not found');
      return;
    }
    
    this.nameElement = this.notification.querySelector('.purchase-notification__name');
    
    if (!this.nameElement) {
      console.warn('Purchase notification name element not found');
      return;
    }
    
    // Setup close button
    const closeButton = this.notification.querySelector('.purchase-notification__close');
    if (closeButton) {
      closeButton.addEventListener('click', () => this.hide());
    }
    
    // Setup click to close on notification content (optional)
    const content = this.notification.querySelector('.purchase-notification__content');
    if (content) {
      content.addEventListener('click', (e) => {
        // Don't close if clicking the close button
        if (!e.target.closest('.purchase-notification__close')) {
          this.hide();
        }
      });
    }
    
    // Start the notification cycle
    this.startNotificationCycle();
  }
  
  getRandomName() {
    const randomIndex = Math.floor(Math.random() * this.femaleNames.length);
    return this.femaleNames[randomIndex];
  }
  
  updateFOMOStock() {
    // Decrease stock by 1-3 items randomly
    const decrease = Math.floor(Math.random() * 3) + 1;
    this.currentStock = Math.max(this.currentStock - decrease, 0);
    
    // Update all FOMO bar texts and progress bars
    const fomoTexts = document.querySelectorAll('.fomo-bar__text[data-fomo-stock]');
    const fomoProgressBars = document.querySelectorAll('.fomo-bar__progress');
    
    fomoTexts.forEach(text => {
      text.textContent = `Only ${this.currentStock} left in stock`;
    });
    
    // Calculate progress bar width (inverse relationship - less stock = less width)
    // Map stock from 0-35 to progress from 5%-50%
    const minWidth = 5;
    const maxWidth = 50;
    const stockRange = this.maxStock;
    const widthRange = maxWidth - minWidth;
    const normalizedStock = this.currentStock / stockRange;
    const progressWidth = Math.max(minWidth, minWidth + (normalizedStock * widthRange));
    
    fomoProgressBars.forEach(bar => {
      bar.style.width = `${progressWidth}%`;
    });
    
    // If stock gets too low, stop notifications but don't reset automatically
    if (this.currentStock < 5) {
      console.log(`Stock is now ${this.currentStock}, notifications will stop`);
    }
  }
  
  show() {
    if (this.isVisible || !this.notification) return;
    
    // Don't show notifications if stock is too low
    if (this.currentStock < 5) {
      console.log('Stock too low, stopping notifications');
      return;
    }
    
    // Update the name with a random female name
    if (this.nameElement) {
      this.nameElement.textContent = this.getRandomName();
    }
    
    // Update FOMO stock when notification appears
    this.updateFOMOStock();
    
    // Remove any existing fade-out class
    this.notification.classList.remove('fade-out');
    
    // Show the notification
    this.notification.style.display = 'block';
    this.isVisible = true;
    
    // Force reflow to ensure display change is applied
    this.notification.offsetHeight;
    
    // Auto-hide after display duration
    setTimeout(() => {
      this.hide();
      // Schedule next notification after this one is completely hidden
      setTimeout(() => {
        this.scheduleNextNotification();
      }, 500); // Small delay after hiding
    }, this.displayDuration);
  }
  
  hide() {
    if (!this.isVisible || !this.notification) return;
    
    // Add fade-out animation
    this.notification.classList.add('fade-out');
    
    // Actually hide after animation completes
    setTimeout(() => {
      this.notification.style.display = 'none';
      this.notification.classList.remove('fade-out');
      this.isVisible = false;
    }, 400); // Match animation duration in CSS
  }
  
  getRandomInterval() {
    return Math.floor(Math.random() * (this.maxIntervalDuration - this.minIntervalDuration + 1)) + this.minIntervalDuration;
  }
  
  scheduleNextNotification() {
    // Don't schedule new notifications if stock is too low
    if (this.currentStock < 5) {
      console.log('Stock too low, not scheduling next notification');
      return;
    }
    
    const randomInterval = this.getRandomInterval();
    this.intervalId = setTimeout(() => {
      if (!this.isVisible) {
        this.show();
      }
    }, randomInterval);
  }
  
  startNotificationCycle() {
    // Show first notification after 5 seconds
    setTimeout(() => {
      this.show();
    }, 5000);
  }
  
  stop() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
      this.intervalId = null;
    }
    this.hide();
  }
  
  // Method to temporarily pause notifications (useful for checkout pages, etc.)
  pause() {
    if (this.intervalId) {
      clearTimeout(this.intervalId);
      this.intervalId = null;
    }
  }
  
  // Method to resume notifications
  resume() {
    if (!this.intervalId) {
      this.scheduleNextNotification();
    }
  }
  
  // Method to manually reset stock (useful for testing or admin purposes)
  resetStock() {
    this.currentStock = Math.floor(Math.random() * 6) + 25; // Reset to 25-30
    console.log(`Stock reset to ${this.currentStock}`);
    this.updateFOMOStock();
    // Resume notifications if they were stopped
    if (!this.intervalId && this.currentStock >= 5) {
      this.scheduleNextNotification();
    }
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Function to check if user is currently in cart context
  function isInCartContext() {
    // Check for cart/checkout pages
    const isCheckoutPage = window.location.pathname.includes('/checkout') || 
                          window.location.pathname.includes('/cart') ||
                          document.body.classList.contains('template-cart');
    
    // Check if cart drawer is open
    const cartDrawer = document.querySelector('cart-drawer');
    const isCartDrawerOpen = cartDrawer && cartDrawer.classList.contains('active');
    
    // Check if cart notification is showing
    const cartNotification = document.querySelector('cart-notification');
    const isCartNotificationOpen = cartNotification && cartNotification.classList.contains('active');
    
    return isCheckoutPage || isCartDrawerOpen || isCartNotificationOpen;
  }
  
  // Don't show on admin or editor pages
  const isAdminPage = window.location.pathname.includes('/admin') ||
                     window.Shopify && window.Shopify.designMode;
  
  if (!isInCartContext() && !isAdminPage) {
    window.purchaseNotification = new PurchaseNotification();
    
    // Set up cart drawer event listeners to pause/resume notifications
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      // Use MutationObserver to watch for class changes on cart drawer
      const cartDrawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isActive = cartDrawer.classList.contains('active');
            
            if (window.purchaseNotification) {
              if (isActive) {
                // Cart drawer is opening - pause notifications
                window.purchaseNotification.pause();
              } else if (!cartDrawer.classList.contains('closing')) {
                // Cart drawer is closed (not just closing) - resume notifications after a delay
                setTimeout(() => {
                  if (window.purchaseNotification && !cartDrawer.classList.contains('active')) {
                    window.purchaseNotification.resume();
                  }
                }, 1000); // Small delay to ensure drawer is fully closed
              }
            }
          }
        });
      });
      
      cartDrawerObserver.observe(cartDrawer, { 
        attributes: true, 
        attributeFilter: ['class'] 
      });
    }
    
    // Also watch for cart notification popup
    const cartNotification = document.querySelector('cart-notification');
    if (cartNotification) {
      const cartNotificationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const isActive = cartNotification.classList.contains('active');
            
            if (window.purchaseNotification) {
              if (isActive) {
                // Cart notification is showing - pause purchase notifications
                window.purchaseNotification.pause();
              } else {
                // Cart notification is hidden - resume purchase notifications after delay
                setTimeout(() => {
                  if (window.purchaseNotification && !cartNotification.classList.contains('active')) {
                    window.purchaseNotification.resume();
                  }
                }, 1000);
              }
            }
          }
        });
      });
      
      cartNotificationObserver.observe(cartNotification, { 
        attributes: true, 
        attributeFilter: ['class'] 
      });
    }
  }
  
  // Initialize FOMO stock display immediately on any page with FOMO bars
  if (window.purchaseNotification) {
    // Set initial stock display without triggering a decrease
    const fomoTexts = document.querySelectorAll('.fomo-bar__text[data-fomo-stock]');
    fomoTexts.forEach(text => {
      text.textContent = `Only ${window.purchaseNotification.currentStock} left in stock`;
    });
  }
});

// Listen for cart updates and fix FOMO display
document.addEventListener('cartUpdate', function() {
  if (window.purchaseNotification) {
    // Pause notifications temporarily during cart update
    window.purchaseNotification.pause();
    
    // Fix FOMO stock display immediately after cart update
    setTimeout(() => {
      const fomoTexts = document.querySelectorAll('.fomo-bar__text[data-fomo-stock]');
      const fomoProgressBars = document.querySelectorAll('.fomo-bar__progress');
      
      fomoTexts.forEach(text => {
        text.textContent = `Only ${window.purchaseNotification.currentStock} left in stock`;
      });
      
      // Update progress bars too
      const minWidth = 5;
      const maxWidth = 50;
      const stockRange = window.purchaseNotification.maxStock;
      const widthRange = maxWidth - minWidth;
      const normalizedStock = window.purchaseNotification.currentStock / stockRange;
      const progressWidth = Math.max(minWidth, minWidth + (normalizedStock * widthRange));
      
      fomoProgressBars.forEach(bar => {
        bar.style.width = `${progressWidth}%`;
      });
    }, 100); // Small delay to ensure DOM is updated
    
    // Resume notifications only if cart drawer/notification is not currently active
    setTimeout(() => {
      if (window.purchaseNotification) {
        const cartDrawer = document.querySelector('cart-drawer');
        const cartNotification = document.querySelector('cart-notification');
        const isCartDrawerOpen = cartDrawer && cartDrawer.classList.contains('active');
        const isCartNotificationOpen = cartNotification && cartNotification.classList.contains('active');
        
        // Only resume if no cart interfaces are currently active
        if (!isCartDrawerOpen && !isCartNotificationOpen) {
          window.purchaseNotification.resume();
        }
      }
    }, 3000); // Shorter delay since we now have proper cart drawer detection
  }
});

// Export for potential external usage
if (typeof module !== 'undefined' && module.exports) {
  module.exports = PurchaseNotification;
} 